import Loader from '@/components/Loader';
import Modal from '@/components/modal/Modal';
import { TAgent, useAddAgentService } from '@/models/agents';
import { Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useState } from 'react';
import AgentServiceEditor from './AgentServiceEditor';

export default function AddAgentService({ agent }: { agent: TAgent }) {
  const [opened, { open, close }] = useDisclosure();
  const [loading, setLoading] = useState(false);
  const { mutate: addService } = useAddAgentService(agent.id);

  return (
    <>
      <Modal
        onClose={close}
        opened={opened}
        title={`Add new service to ${agent.name}`}
        styles={{ body: { padding: 'sm' } }}
      >
        {loading && <Loader />}
        <AgentServiceEditor
          buttonTitle="Add"
          onSubmit={(service) => {
            addService(service, {
              onSettled: () => {
                setLoading(false);
                close();
              },
            });
            setLoading(true);
          }}
        />
      </Modal>
      <Button onClick={open} size="xs" variant="light" mt={'md'}>
        Create new service
      </Button>
    </>
  );
}
